import { z } from "zod";

import { NIKE_URL } from "@/data/constants/url";
import { createErrorMessage } from "@/utils/create-error-message";

const resolveSymbolResponseSchema = z.object({
  data: z.object({
    name: z.string(),
    "exchange-traded": z.string(),
    "exchange-listed": z.string(),
    timezone: z.string().nullable(),
    minmov: z.number().nullable(),
    minmov2: z.number().nullable(),
    pointvalue: z.number().nullable(),
    session: z.string().nullable(),
    has_intraday: z.boolean(),
    visible_plots_set: z.string().nullish(),
    description: z.string(),
    type: z.string(),
    supported_resolutions: z.array(z.string()),
    pricescale: z.number(),
    ticker: z.string(),
    logo_urls: z.array(z.string()),
    exchange_logo: z.string().nullable(),
    has_daily: z.boolean().nullish(),
    format: z.string().nullish(),
    exchange: z.string().nullish(),
  }),
  message: z.string(),
});

export type ResolveSymbolResponse = z.infer<typeof resolveSymbolResponseSchema>;
export type ResolveSymbolData = ResolveSymbolResponse["data"];

export const resolveSymbol = async ({
  symbol,
}: {
  symbol: string;
}): Promise<ResolveSymbolData> => {
  const url = new URL(`${NIKE_URL}/tradingview-chart/symbols`);
  url.searchParams.set("symbol", symbol);
  const res = await fetch(url.toString(), {
    method: "GET",
    cache: "no-cache",
  });
  if (!res.ok) {
    const errorMessage = await createErrorMessage(url.toString(), res);
    throw new Error(errorMessage);
  }
  return resolveSymbolResponseSchema.parse(await res.json()).data;
};
